import { useContext } from 'react';
import { OverridesContext } from "./OverridesContext.js";
import Button from "../controls/Button/index.js";
import Select from "../controls/Select/index.js";
import TextInput from "../controls/TextInput/index.js";
import RadioInput from "../controls/RadioInput/index.js";
import CheckboxInput from "../controls/CheckboxInput/index.js";
import FilterField from "../layouts/FilterField/index.js";
import InlineControlGroup from "../layouts/InlineControlGroup/index.js";
import OverlayHeader from "../layouts/TwoColumnOverlayMapLayout/OverlayHeader/index.js";
import OverlayHeaderText from "../layouts/TwoColumnOverlayMapLayout/OverlayHeaderText/index.js";
import OverlayToggleButton from "../layouts/TwoColumnOverlayMapLayout/OverlayToggleButton/index.js";
import NoResults from "../results/NoResults/index.js";
import ResultItem from "../results/ResultItem/index.js";
import GroupHeader from "../results/GroupHeader/index.js";
import ResultGroup from "../results/ResultGroup/index.js";
import SortIndicator from "../results/SortIndicator/index.js";
import PopoverContent from "../GoogleMaps/Popover/PopoverContent/index.js";
import PopoverCloseButton from "../GoogleMaps/Popover/PopoverCloseButton/index.js";
import PopoverHeading from "../GoogleMaps/Popover/PopoverHeading/index.js";
export var defaultComponentOverrides = {
  'results/NoResults': NoResults,
  'results/ResultItem': ResultItem,
  'results/GroupHeader': GroupHeader,
  'results/ResultGroup': ResultGroup,
  'results/SortIndicator': SortIndicator,
  'controls/Button': Button,
  'controls/Select': Select,
  'controls/TextInput': TextInput,
  'controls/RadioInput': RadioInput,
  'controls/CheckboxInput': CheckboxInput,
  'layout/InlineControlGroup': InlineControlGroup,
  'layouts/FilterField': FilterField,
  'layouts/TwoColumnOverlayMapLayout/OverlayHeader': OverlayHeader,
  'layouts/TwoColumnOverlayMapLayout/OverlayHeaderText': OverlayHeaderText,
  'layouts/TwoColumnOverlayMapLayout/OverlayToggleButton': OverlayToggleButton,
  'GoogleMaps/Popover/PopoverContent': PopoverContent,
  'GoogleMaps/Popover/PopoverCloseButton': PopoverCloseButton,
  'GoogleMaps/Popover/PopoverHeading': PopoverHeading
};
export var useComponentOverride = function useComponentOverride() {
  var ctx = useContext(OverridesContext);
  var components = [];
  for (var _len = arguments.length, componentNames = new Array(_len), _key = 0; _key < _len; _key++) {
    componentNames[_key] = arguments[_key];
  }
  for (var componentName of componentNames) {
    var override = ctx.components[componentName];
    if (override) {
      components.push(override);
    } else {
      components.push(defaultComponentOverrides[componentName]);
    }
  }
  return components;
};
export default useComponentOverride;
//# sourceMappingURL=useComponentOverride.js.map